import React, { MouseEventHandler } from 'react';
import { Tooltip } from 'antd';
import styled from 'styled-components';
import { POILocation } from '../../types/Track';
import { LocationCodeStandard } from '../../common/api/spidertracks-sdk/types/Organisation';

export const LocationStyle = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  color: #1890ff;
`;

interface LocationCellProps {
  locationToBeAdded: boolean;
  location: POILocation | undefined | null;
  locationCodePreference: LocationCodeStandard;
  onClick: MouseEventHandler;
}

const LocationCell: React.FC<LocationCellProps> = ({
  locationToBeAdded,
  location,
  locationCodePreference,
  onClick
}) => {
  if (location == undefined || location == null) {
    if (locationToBeAdded) {
      return <>...</>;
    } else {
      return <></>;
    }
  }

  let toolTip = location.name;
  let displayText = location.customCode; // custom one has 1st priority

  if (displayText == undefined) {
    if (locationCodePreference == LocationCodeStandard.IATA) {
      displayText = location.IATA
        ? location.IATA
        : location.ICAO
        ? location.ICAO
        : location.GPSCode ?? undefined;
    } else {
      displayText = location.ICAO
        ? location.ICAO
        : location.IATA
        ? location.IATA
        : location.GPSCode ?? undefined;
    }
  }

  if (displayText == undefined && toolTip == undefined) {
    displayText = '(unknown)';
    toolTip = 'No location found; click to update';
  } else if (displayText == undefined) {
    displayText = '(no code)';
  }

  return (
    <LocationStyle onClick={onClick}>
      <Tooltip placement="bottom" trigger="hover" title={toolTip}>
        <div>{displayText}</div>
      </Tooltip>
    </LocationStyle>
  );
};
export default LocationCell;
